(() => {
  const resolveRecommendations = () => {
    document.querySelectorAll('product-recommendations').forEach((root) => {
      if (root.dataset.cardcAestheticChecked === 'true') return;
      root.dataset.cardcAestheticChecked = 'true';
      window.setTimeout(() => {
        const hasCards = root.querySelectorAll('product-card').length > 0;
        if (!hasCards) root.classList.add('cardc-recommendations-empty');
      }, 2800);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', resolveRecommendations, { once: true });
  else resolveRecommendations();
  document.addEventListener('shopify:section:load', resolveRecommendations);
})();
